module.exports = __webpack_public_path__ + "img/電気回路_6_7_5.75a888f0.png";